import React, { useState } from 'react';
import './GroupsSidebar.css';
import CreateGroupModal from './CreateGroupModal';

const GroupsSidebar = ({ groups, selectedGroup, onSelectGroup, user, onGroupCreated }) => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const handleOpenCreateGroupModal = () => {
    setShowCreateModal(true);
  };

  const handleGroupCreated = async (newGroup) => {
    // Refresh the groups list by notifying the parent component
    if (onGroupCreated) {
      onGroupCreated(newGroup);
    }
    setShowCreateModal(false);
  };

  return (
    <aside className="groups-sidebar">
      <div className="groups-sidebar-header">
        <span className="groups-sidebar-title">Study Groups</span>
      </div>
      <div className="groups-sidebar-searchbar-container">
        <input
          type="text"
          className="groups-sidebar-searchbar"
          placeholder="Search groups..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          aria-label="Search groups"
        />
      </div>
      <div className="create-group-btn-container">
        <button
          className="create-group-btn"
          onClick={handleOpenCreateGroupModal}
          aria-label="Create New Group"
        >
          + Create New Group
        </button>
      </div>
      <div className="groups-list-label">Study Groups You've joined in</div>
      <ul className="groups-list">
        {groups.filter(group => group.name.toLowerCase().includes(searchTerm.toLowerCase())).map(group => (
          <li
            key={group.id}
            className={`group-list-item${selectedGroup === group.id ? ' active' : ''}`}
            onClick={() => onSelectGroup(group.id)}
          >
            <img src={group.group_banner_url || '/default-group.png'} alt={group.name} className="group-avatar" />
            <span className="group-name">{group.name}</span>
          </li>
        ))}
      </ul>

      {showCreateModal && (
        <CreateGroupModal
          user={user}
          onClose={() => setShowCreateModal(false)}
          onGroupCreated={handleGroupCreated}
        />
      )}
    </aside>
  );
};

export default GroupsSidebar;